var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":_vm.handleClick}},[_c('v-icon',[_vm._v("mdi-view-grid-outline")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }